import { render, staticRenderFns } from "./chat-message-box.vue?vue&type=template&id=7efc3b88&scoped=true&"
import script from "./chat-message-box.vue?vue&type=script&lang=js&"
export * from "./chat-message-box.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-box.vue?vue&type=style&index=0&id=7efc3b88&lang=less&scoped=true&"
import style1 from "./chat-message-box.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efc3b88",
  null
  
)

export default component.exports